import { createRoot } from "react-dom/client";
import "@rg/ui/styles/variable.css";
import "@rg/ui/styles/fonts.css";
import "@rg/ui/styles/typography.css";
import { reportLCP } from "@/common/utils/reportLCP";
import { startWebVitals } from "@/common/utils/webVitals";
import { AppContainer } from "components/app-lite/AppContainer";

const root = createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<AppContainer />);

reportLCP();
startWebVitals();
